"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _sources = require("@studio/sources");
var _program = require("@studio/program");
var _types = require("./types");
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Since we have different setProgram for lite and pro
 * then the setProgram action will have to be passed in as an argument.
 *
 * @param presenterId This set a featured presenter.
 * @param setProgram set program action r
 * @returns {(function(*, *, *): void)|*}
 */
function setFeaturedPresenter(presenterId, setProgram) {
  return function (dispatch, getState) {
    var _getState = getState(),
      banners = _getState.banners,
      sceneLayout = _getState.sceneLayout,
      sceneLayers = _getState.sceneLayers,
      attendeeMuteStatus = _getState.attendeeMuteStatus,
      layers = _getState.program.layers,
      brandingSettings = _getState.brandingSettings;
    var combinedLayers = [].concat(_toConsumableArray(sceneLayers), _toConsumableArray(banners));
    var sources = layers.map(function (_ref) {
      var source = _ref.source,
        _id = _ref._id;
      return _objectSpread(_objectSpread({}, source), {}, {
        featured: _id === presenterId
      });
    });
    var withAudioPresenterSources = (0, _sources.attachAudioPresenterSources)(sources, attendeeMuteStatus);
    var scene = (0, _program.sceneBuilder)(sceneLayout, withAudioPresenterSources, combinedLayers, {}, {}, brandingSettings === null || brandingSettings === void 0 ? void 0 : brandingSettings.fonts);

    // add presenterId on the payload object so that it's available on
    // notifyDirectors middleware
    var action = {
      type: _types.BROADCAST_SET_FEATURED_PRESENTER,
      payload: {
        presenterId: presenterId
      }
    };
    var isLiveSource = (0, _sources.isSourceInProgram)(layers, presenterId);
    dispatch(action);
    if (isLiveSource) {
      dispatch(setProgram(scene));
      (0, _sendToDatadogWithIds.logProgramChange)(getState, 'setFeaturedPresenter action');
    }
  };
}
var _default = exports["default"] = setFeaturedPresenter;